/**
 * Payroll engine numeric/parsing ports — EXACT semantics of v2.9
 * (docs/Payroll/PayrollAutomation_v2.gs utilities). Do not "fix" these:
 *   - toNum strips parens, so "(500)" parses to +500 (SD-8).
 *   - round2 is Math.round → half toward +Infinity, not half away from zero (SD-1).
 * Pure module — no Node builtins, no dependencies (shared with the frontend bundle).
 */

/** v2.9 toNum_: blank → NaN; strings strip $ , ( ) and whitespace then parseFloat. */
function toNum(v) {
  if (v === '' || v === null || v === undefined) return NaN;
  return parseFloat(String(v).replace(/[$,()\s]/g, ''));
}

/** v2.9 num_: toNum with a default; default undefined → null when NaN. */
function num(v, dflt) {
  const n = toNum(v);
  return isNaN(n) ? (dflt === undefined ? null : dflt) : n;
}

/** v2.9 round2_: cents rounding via Math.round (half toward +Infinity). */
function round2(n) {
  return Math.round(n * 100) / 100;
}

/** v2.9 fmt_: thousands-grouped 2-decimal string for narratives. */
function fmt(n) {
  return Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/** v2.9 parseDate_: Date passes through; anything else via new Date(); invalid → null. */
function parseDate(v) {
  if (v instanceof Date && !isNaN(v.getTime())) return v;
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

/** v2.9 canonicalEmail_: trim + lowercase + alias map. */
function canonicalEmail(v, aliases) {
  const e = String(v || '').trim().toLowerCase();
  if (!e) return '';
  return (aliases && aliases[e]) || e;
}

/** v2.9 isW2_: strip non-alphanumerics, uppercase, compare to "W2". */
function isW2(prof) {
  return !!prof && String(prof.w2 || '').replace(/[^A-Z0-9]/gi, '').toUpperCase() === 'W2';
}

module.exports = { toNum, num, round2, fmt, parseDate, canonicalEmail, isW2 };
